import { useTranslation } from 'react-i18next';
import { FaDownload } from 'react-icons/fa';
import { FiChevronDown } from 'react-icons/fi';
import { Button, Menu } from '@mantine/core';
import { useMutation } from '@tanstack/react-query';

import showToast from 'actions/toastActions';
import {
  download811csv,
  downloadSoilCollectorExport,
  downloadSupportingDocs,
} from 'store/projects/requests';

type Props = {
  samplingPlanId: number;
};

const SamplingPlanDownloadMenu = ({ samplingPlanId }: Props) => {
  const { t } = useTranslation();

  const download811mutation = useMutation({
    mutationFn: () => download811csv(samplingPlanId),
    onMutate: () => {
      showToast(t('thisMayTakeSeconds'), undefined, undefined, {
        title: t('download811msg'),
      });
    },
  });

  const downloadsoilCollectorExportMuation = useMutation({
    mutationFn: () => downloadSoilCollectorExport(samplingPlanId),
    onMutate: () => {
      showToast(t('thisMayTakeSeconds'), undefined, undefined, {
        title: t('downloadSoilCollectorExportMsg'),
      });
    },
  });

  const downloadSupportingDocsMutation = useMutation({
    mutationFn: async () => {
      try {
        const response = await downloadSupportingDocs(samplingPlanId);
        const signed_url = (await response.json()) || undefined;
        return { signed_url };
      } catch (error) {
        return { signed_url: undefined };
      }
    },
    onSuccess: (data: { signed_url?: string }) => {
      if (data.signed_url) {
        window.open(data.signed_url, '_blank');
      } else {
        showToast(t('downloadSupportingDocsErrorMsg'), 'error');
      }
    },
    onError: () => {
      showToast(t('downloadSupportingDocsErrorMsg'), 'error');
    },
    onMutate: () => {
      showToast(t('thisMayTakeSeconds'), undefined, undefined, {
        title: t('downloadSupportingDocsMsg'),
      });
    },
  });

  return (
    <Menu shadow="md">
      <Menu.Target>
        <Button leftSection={<FaDownload />} size="sm" rightSection={<FiChevronDown />}>
          {t('download')}
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item onClick={() => download811mutation.mutate()}>811 CSV</Menu.Item>
        <Menu.Item onClick={() => downloadsoilCollectorExportMuation.mutate()}>
          {t('soilCollectorOutput')}
        </Menu.Item>
        <Menu.Item onClick={() => downloadSupportingDocsMutation.mutate()}>
          {t('supportingDocs')}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default SamplingPlanDownloadMenu;
